<div class="picklist-editor-dialog">
  <h2 mat-dialog-title>
    {{dialog.title}}
  </h2>
  <div mat-dialog-content
    class="content">
    <div [innerHTML]="dialog.content"></div>
    <mat-form-field class="picklist-editor-dialog__filter"
      appearance="fill">
      <mat-label>Filter by handheld display & inspection report</mat-label>
      <input matInput
        type="text"
        [ngModel]="filterPickListTxt"
        (ngModelChange)="filterPickList($event)">
      </mat-form-field>

      <inspekt-dynamic-form [fields]="dialog.fields"
      [form]="form" />

      @if (showAddingPickListOptions) {
        <div>
          <mat-form-field appearance="outline"
            style="width:40%">
            <mat-label>{{'PICK_LIST_EDITOR.PICK_LIST_ITEM_DESC' | translate}}</mat-label>
            <input matInput
              [(ngModel)]="newOptionDescription">
            </mat-form-field>
            <mat-form-field appearance="outline"
              style="width:40%">
              <mat-label>{{'PICK_LIST_EDITOR.PICK_LIST_ITEM_VALUE' | translate}}</mat-label>
              <input matInput
                [(ngModel)]="newOptionEnum">
              </mat-form-field>
              <button mat-icon-button
                (click)="addNewPickListOption()"
                [disabled]="allowToCreatePickListOption">
                <mat-icon matTooltip="Add new option"
                matTooltipShowDelay="300">add</mat-icon>
              </button>
            </div>
          }
          @if (allowToAddPickListOption) {
            <button mat-raised-button
              class="tenant-bg-primary-color dialog-button"
              type="submit"
              color="accent"
              (click)="toggleAddPickListOptionElement()">
              <mat-icon matTooltip="Add new option from Picklist"
              matTooltipShowDelay="300">add</mat-icon>
              {{'PICK_LIST_EDITOR.ADD_NEW' | translate}}
            </button>
          }
        </div>
        @if (form) {
          <div mat-dialog-actions
            class="action"
            >
            <button class="dialog-button submit"
              mat-raised-button
              color="accent"
              (click)="ok()"
            [disabled]="pickListOptionNumber < 1">{{'BUTTONS.OK'| translate}}</button>
            @if (dialogRef.componentInstance.dialog.showCancelButton) {
              <button
                mat-button
                (click)="cancel()"
              class="dialog-button">{{'BUTTONS.CANCEL'| translate}}</button>
            }
          </div>
        }
      </div>
